import { useTranslation } from 'react-i18next';
import KizenTypography from 'app/kizentypo';
import {
  useAutomationsDispatch,
  useAutomationsSelector,
} from 'pages/AutomationEngine/store/react';
import { actions } from 'pages/AutomationEngine/store';
import TriggerCard from '../TriggerCard';
import {
  getHistoryId,
  getExecutionMode,
} from 'pages/AutomationEngine/store/selectors';

export const content = ({ t }) => {
  return t('Add Trigger');
};

export default function AddTriggerCard({ type, step, ...others }) {
  const { t } = useTranslation();
  const dispatch = useAutomationsDispatch();
  const historyId = useAutomationsSelector(getHistoryId);
  const executionMode = useAutomationsSelector(getExecutionMode);
  const disableFeatures = historyId || executionMode;
  return (
    <TriggerCard
      {...others}
      addMenu={false} // never show a menu
      onClick={(e) =>
        disableFeatures ? null : dispatch(actions.createTrigger())
      }
    >
      <KizenTypography
        data-qa="add-trigger-btn"
        {...(disableFeatures
          ? { as: 'span' }
          : { type: 'anchor', href: '', onClick: (e) => e.preventDefault() })}
      >
        {t('Click to add new trigger')}
      </KizenTypography>
    </TriggerCard>
  );
}
